import { request } from '@umijs/max';

// 获取用户列表
export async function getUserPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/user/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取全部用户
export async function getUserAll({ filter }: { filter: API.FormValues }) {
  return request('/api/admin/user/all', {
    method: 'POST',
    data: {
      filter,
    },
  });
}

// 获取用户详情
export async function getUserInfo(values: API.FormValues) {
  return request('/api/admin/user/info', {
    method: 'POST',
    data: values,
  });
}

// 创建用户
export async function addUser(values: API.FormValues) {
  return request('/api/admin/user/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑用户
export async function editUser(values: API.FormValues) {
  return request('/api/admin/user/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除用户
export async function removeUser(values: API.FormValues) {
  return request('/api/admin/user/remove', {
    method: 'POST',
    data: values,
  });
}
